import * as Rx from 'rxjs/Rx'
import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { App, EventHub, Login, World } from '../../actions'
import { CRAWLER_USER_AGENTS } from '../constants'

// Kick off app data loading after the app launched
export const launchApp = (
  _action$: ActionsObservable<Action>,
  _store: Store<State>,
  { logger, scheduler, mobileVersion }: Dependencies
) =>
  Rx.Observable
    .of(App.launched({ mobileVersion }))
    // We need to delay for a little while, so that other epics have a chance
    // to start subscription. Otherwise Rx.Observable.of will emit immediately,
    // then nobody will be able to see it if this epic happens to start at
    // the first place
    .delay(0, scheduler)
    .do(() => {
      logger.info('Start loading app data')
    })

// Kick off credentials loading
export const loadCredentials = (
  action$: ActionsObservable<Action>,
  _store: Store<State>,
  { logger }: Dependencies
) =>
  action$.filter(App.launched.match).switchMap(() => {
    if (CRAWLER_USER_AGENTS.test(navigator.userAgent)) {
      logger.info('Crawler user-agent, do not load credentials')
      return Rx.Observable.empty()
    }
    logger.info('Start loading credentials ')
    return Rx.Observable.of(Login.loadCredentials.started(undefined))
  })

// post action message to mobile app
export const postMessage = (
  action$: ActionsObservable<Action>,
  _store: Store<State>,
  { mobileVersion }: Dependencies
) =>
  action$
    .do(action => {
      if (!mobileVersion) {
        return
      }
      if (
        World.eventProcessed.match(action) ||
        World.localEventUpdate.match(action) ||
        EventHub.eventUpdate.match(action)
      ) {
        return
      }
      const anyWindow = window as any
      if (
        anyWindow.webkit &&
        anyWindow.webkit.messageHandlers &&
        anyWindow.webkit.messageHandlers.reactNative &&
        anyWindow.webkit.messageHandlers.reactNative.postMessage
      ) {
        anyWindow.webkit.messageHandlers.reactNative.postMessage(action)
      } else {
        window.postMessage(JSON.stringify(action), '*')
      }
    })
    .ignoreElements()

export default combineEpics<Epic>(launchApp, loadCredentials, postMessage)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/shared/app.ts